const reviews = [
  {
    id: 1,
    image: './images/ayoub.jpeg',
    name: 'Ayoub Maimmadi',
    title: 'SSE Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 2,
    image: './images/rabii.PNG',
    name: 'Rabii Alaoui',
    title: 'SSE Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 3,
    image: './images/imane.PNG',
    name: 'Imane Ettabaa',
    title: 'SSE Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 4,
    image: './images/hiba.jpeg',
    name: 'Hiba Akhaddar',
    title: 'SSE Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 5,
    image: './images/jiji.PNG',
    name: 'Abderrahmane Jibrane',
    title: 'BA Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 6,
    image: './images/nour.PNG',
    name: 'Noure Eddine Jenhaji',
    title: 'EMS Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 7,
    image: './images/ayman.PNG',
    name: 'Ayman Tardaoui',
    title: 'BA Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 8,
    image: './images/taha.PNG',
    name: 'Taha Samih',
    title: 'EMS Student',
    quote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
]

export default reviews
